// import appsAndPages from './apps-and-pages'
// import chartsAndMaps from './charts-and-maps'
// import uiElements from './ui-elements'
import panel from './panel'
export default [...panel]
